import * as angular from 'angular';

// This directive is used to ensure the appropriate controller binding to the modal template
const sqlSettingsModalDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      preferences: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.sqlSettings', () => {
        Modal.open(
          {
            preferences: $scope.preferences,
          },
          {
            controllerAs: 'ctrl',
            bindToController: true,
            template: '<sql-settings preferences="preferences" on-submit="$close()" on-cancel="$dismiss()"/>',
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.sqlSettings'));
    },
  };
};

sqlSettingsModalDirective.$inject = ['ModalService'];

// IMPORTANT - Don't forget to also update the /frontend/src/core-app file with an import of this directive.
angular.module('mode.components').directive('sqlSettingsModal', sqlSettingsModalDirective);
